import { Placement } from "@floating-ui/react";

const arrowPositionClasses = {
  top: "-bottom-1 left-1/2 -translate-x-1/2",
  bottom: "-top-1 left-1/2 -translate-x-1/2",
  left: "-right-1 top-1/2 -translate-y-1/2",
  right: "-left-1 top-1/2 -translate-y-1/2",
} as const;

/**
 * The little point on a white tooltip, on the edge facing the thing it
 * describes. Pass the placement the tooltip actually ended up in, so the point
 * follows it when the tooltip flips to the other side.
 */
export default function TooltipArrow(p: Readonly<{ placement: Placement }>) {
  const side = p.placement.split("-")[0] as keyof typeof arrowPositionClasses;
  return (
    <div
      className={`absolute h-2 w-2 rotate-45 bg-white ${arrowPositionClasses[side]}`}
    />
  );
}
